module.exports = __webpack_public_path__ + "static/logo-circle-light-c20daca25ca63163e3a3062aba30343d.png";